import  getNodeReinforcementCSVAttachments from './getNodeReinforcementCSVAttachments'
const TIPO_POSITION = 3
const COPRIFERRO_POSITION = 6
const C_TRAVE_1_POSITION = 10
const columns_to_remove = []
const getRecursiveQuestionsTableModeCSVAttachments = (recQuestionsTableMode, copriferro, getOptionTitle, sep = ';') => {
  let attachments = []
  for (let recQuestionTableMode of recQuestionsTableMode) {
    let columns = {}
    let rows = []
    let recQuestionsResponses = recQuestionTableMode.recursive_question_value
    for (let recQuestionResponse of recQuestionsResponses) {
      for (let id of Object.keys(recQuestionResponse)) {
        let column_name = recQuestionResponse[id].question.column_name
        if (!columns_to_remove.includes(column_name.toLowerCase())) {
          if (recQuestionResponse[id].question.metadata_) {
            if (recQuestionResponse[id].question.metadata_.hasOwnProperty('symbol_question')) {
              column_name += recQuestionResponse[id].question.metadata_.symbol_question
            }
            if (recQuestionResponse[id].question.metadata_.hasOwnProperty('uom_question')) {
              column_name += " [" + recQuestionResponse[id].question.metadata_.uom_question + "]"
            }
          }
          columns[id] = {id: id, name: column_name, order: recQuestionResponse[id].question.order}        }
      }
    }
    columns = Object.values(columns)
    columns.sort((a, b) => a.order - b.order)
    for (let recQuestionResponse of recQuestionsResponses) {
      let row = {}
      for (let {id, column_name, order} of columns) {
        let value = ""
        if (recQuestionResponse.hasOwnProperty(id)) {
          switch (recQuestionResponse[id].question.input_type) {
            case 'select':
              // value = getOptionTitle(recQuestionResponse[id].option)
              value = getOptionTitle(recQuestionResponse[id].question.options.find(o => o.id === parseInt(recQuestionResponse[id].value)))
              break;
            case 'multi_select':
              // @TODO: MULTISELECT
              break;
            case 'number_input':
            case 'text_input':
            case 'bool':
              value = recQuestionResponse[id].value
          }
        }
        row[id] = value
      }
      rows.push(row)
    }
    let csvContent = ""
    let position = 1
    for (let {id, name, order} of columns) {
      switch(position){
        case TIPO_POSITION:
          csvContent += 'tipo' + sep
          position++
          break;
        case COPRIFERRO_POSITION:
          csvContent += 'copriferro [mm]' + sep
          csvContent += 'id_mat (conc)' + sep
          position += 2
          break;
        case C_TRAVE_1_POSITION:
          csvContent += 'ctrave1 [mm]' + sep
          position++
          break;
        default:
            // nothing
      }
      csvContent += name + sep
      position++
    }
    csvContent = csvContent.slice(0, -1) + "\n"

    for (let row of rows) {
      position = 1
      for (let {id, name, order} of columns) {
        switch (position) {
          case TIPO_POSITION:
            csvContent += recQuestionTableMode.question.name.split('_').slice(-1)[0] + sep
            position++
            break;
          case COPRIFERRO_POSITION:
            csvContent += `${copriferro}` + sep
            csvContent += '1' + sep
            position += 2
            break;
          case C_TRAVE_1_POSITION:
            csvContent += `${copriferro}` + sep
            position++
            break;
          default:
            // nothing
        }
        csvContent += row[id] + sep
        position++
      }
      csvContent = csvContent.slice(0, -1) + "\n"
    }
    attachments.push({
      "Body": btoa(csvContent),
      "ContentType": "text/csv",
      "Name": recQuestionTableMode.question.title + ".csv"
    })
  }
  return attachments
}

const getTCSAttachments = (recursiveQuestions, nodeReinforcement, getOptionTitle) => {
  let copriferro = nodeReinforcement.value.copriferro
  let recursiveQuestionTableModeAttachments = getRecursiveQuestionsTableModeCSVAttachments(recursiveQuestions, copriferro, getOptionTitle)
  let nodeReinforcementAttachments = getNodeReinforcementCSVAttachments([nodeReinforcement])
  return [...recursiveQuestionTableModeAttachments, ...nodeReinforcementAttachments]
}

export default getTCSAttachments;